import { render, staticRenderFns } from "./OzInput.vue?vue&type=template&id=b679b3cc&scoped=true&"
import script from "./OzInput.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzInput.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OzInput.vue?vue&type=style&index=0&id=b679b3cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b679b3cc",
  null
  
)

export default component.exports